import { useQuery } from "@apollo/client";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { TerraformProviderVersionArtifact } from "types/generated";
import { downloadFileFromURL } from "utils/file";

import { GET_DOWNLOADABLE_PROVIDER_VERSION_ARTIFACT_URL } from "../gql";
import { GetDownloadableProviderVersionArtifactUrlGql } from "./type";

type UseDownloadArtifactParams = {
  providerId: string;
  versionNumber: string;
};

const useDownloadArtifact = ({ providerId, versionNumber }: UseDownloadArtifactParams) => {
  const { onError, reportError } = useTypedContext(FlashContext);

  const { refetch: getLink, loading } = useQuery<GetDownloadableProviderVersionArtifactUrlGql>(
    GET_DOWNLOADABLE_PROVIDER_VERSION_ARTIFACT_URL,
    {
      skip: true,
      fetchPolicy: "no-cache",
    }
  );

  const handleDownloadArtifact = (artifact: TerraformProviderVersionArtifact) => {
    getLink({
      artifactFilename: artifact.filename,
      versionNumber,
      providerId,
    })
      .then(({ data }) => {
        if (data?.terraformProvider?.version?.artifactDownloadUrl) {
          downloadFileFromURL(data.terraformProvider.version.artifactDownloadUrl);
        } else {
          reportError({
            message: "Something went wrong while generating a download URL, please try again.",
          });
        }
      })
      .catch(onError);
  };

  return { handleDownloadArtifact, loading };
};

export default useDownloadArtifact;
